
    import {
        defineComponent, ref, unref,
    } from 'vue';

    import clickOutside from '@ve/services/directives/clickOutside';
    import clickEsc from '@ve/services/directives/clickEsc';

    export default defineComponent({
        name: 'dropdown',
        directives: {
            clickOutside,
            clickEsc,
        },
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        setup() {
            const opened = ref(false);

            const close = () => {
                opened.value = false;
            };
            const open = () => {
                opened.value = true;
            };

            const toggle = () => (unref(opened) ? close() : open());

            return {
                opened,
                close,
                open,
                toggle,
            };
        },
    });
